// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record, Map } from "immutable"
import { isNil, pick } from "ramda"

import { placeToLocationTypes } from "../services/locations/placeLocationMapper"

export type City = {
  id: string
  name: string
}

const PlaceRecord = Record({
  id: null,
  value: "", // whole name with brackets
  slug: "", // url slug
  lat: null,
  lng: null,
  type: null, // type in integer
  flagParentId: null,
  parentIds: [],
  population: null, // not used
  country: null, // deprecated! it is somewhere used as object, don't use it like that, in future it could be used for country string
  rank: 0,
  numberOfAirports: 0,
  city: null,
  station: null,
  code: "",
  name: "",
  countryName: "", // TODO: merge this with country prop to an object (needs bigger refactor)
  continent: null,
  tags: null,
  neighbours: null,
  typeName: "",
  region: null,
})

class Place extends PlaceRecord {
  // @ts-expect-error: Flow to TS migration.
  id: string

  // @ts-expect-error: Flow to TS migration.
  value: string

  // @ts-expect-error: Flow to TS migration.
  slug: string

  lat: number | null | undefined

  lng: number | null | undefined

  // @ts-expect-error: Flow to TS migration.
  type: number

  flagParentId: string | null | undefined

  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/array-type
  parentIds: Array<string>

  // @ts-expect-error: Flow to TS migration.
  population: number

  // @ts-expect-error: Flow to TS migration.
  rank: number

  city: City | null | undefined

  // @ts-expect-error: Flow to TS migration.
  code: string

  name: string | null | undefined

  station: string | null | undefined

  // @ts-expect-error: Flow to TS migration.
  numberOfAirports: number

  countryName: string | null | undefined

  continent: string | null | undefined

  tags:
    | {
        tag: string
      }[]
    | null
    | undefined

  neighbours: string[] | null | undefined

  // @ts-expect-error: Flow to TS migration.
  typeName: string

  region: string | null | undefined

  getId(): string {
    return this.get("id")
  }

  getType(): string {
    // @ts-expect-error: Flow to TS migration.
    return placeToLocationTypes[this.get("type")] || "unknown"
  }

  checkLatLng(): boolean {
    return (
      !isNil(this.get("lat")) &&
      !isNil(this.get("lng")) &&
      !(this.get("lat") === 0 && this.get("lng") === 0)
    )
  }

  isIncludedDeepIn(where: (string | null | undefined)[]): boolean {
    return this.parentIds.some((id) => where.includes(id))
  }

  getGeo() {
    return !isNil(this.lat) && !isNil(this.lng) && pick(["lat", "lng"], this)
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering, @typescript-eslint/no-explicit-any
  static fromPlainJS(plain: any | null = {}): Place {
    return new Place(plain)
  }
}

export const PlacesStateRecord = Record({
  places: Map({}),
  loading: true,
  error: false,
})

export default Place
